import React from "react";
import s from './Trabajos.module.css'

export default function Trabajos() {
    return(
        <h1 className={s.h111}>Esto es Trabajo!!!!</h1>
    )
}